import { render } from "./ROUCASS26_keep_inscription.vue?vue&type=template&id=6571d109"
import script from "./ROUCASS26_keep_inscription.vue?vue&type=script&lang=js"
export * from "./ROUCASS26_keep_inscription.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__